import React from "react";
import { Form, Input, DatePicker, Select } from "antd";
import { Card, CardBody, Row, Col } from "reactstrap";
import { PanelHeader, Button } from "components";
// import 'antd/dist/antd.css';
import moment from "moment";
import "moment/locale/es";
// import CKEditor from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import dayjs from "dayjs";
import "dayjs/locale/es";
dayjs.locale("es");

const { Option } = Select;

class NewReminder extends React.Component {
  constructor(props) {
    super(props);
    let reminderFromCalendar = this.getReminderFromCalendar();
    this.state = {
      title: reminderFromCalendar ? reminderFromCalendar.title : "",
      description: "",
      startDate: reminderFromCalendar ? dayjs(reminderFromCalendar.start) : null,
      category: ""
    };
    this.getReminderFromCalendar = this.getReminderFromCalendar.bind(this);
  }
  getReminderFromCalendar() {
    let reminder = localStorage.getItem('reminder_from_calendar');
    if (reminder) reminder = JSON.parse(reminder);
    localStorage.removeItem('reminder_from_calendar');
    return reminder;
  }

  componentDidMount() {
    this.props.userData.getTechniciansList();
  }

  handleSubmit = () => {
    if (!this.validateForm()) return;
    console.log("handleSubmit (this.state)", this.state);
    let reminder = {
        title: this.state.title,
        date: this.state.startDate.format("YYYY-MM-DD HH:mm"),
        description: this.state.description,
        category: this.state.category,
        type: this.state.type,
        shared: this.state.shared
    };
    console.log("handleSubmit (reminder)", reminder);
    this.createReminder(reminder);
    // console.log(this.state);
    // console.log(reminder);
  };
  
  createReminder = (reminder) => {
    // console.log("orders: ", orders);
    this.setState({ creatingReminder: true });
    this.props.userData
      .createReminder(reminder)
      .then(result => {
        if (result.ok) {
            // this.setState({ creatingReminder: false });
            this.redirectTo("/recordatorios");
        } else {
            this.setState({ creatingReminder: false });
            // this.redirectTo("/recordatorios");
        }
      })
      .catch((error) => {
        this.setState({ creatingReminder: false });
        // Error 😨
        console.log("Error al crear el recordatorio: " + error.message);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
    // filter.page = filter.page - 1;
  }

  redirectTo = (redirect) => {
    this.props.history.push(redirect);
  }

  handleChange = (e, field) => {
    this.setState({ [field]: e.target.value });
  };

  handleDateChange = (date, dateString) => {
    this.setState({ startDate: date });
  };

  handleCategoryChange = value => {
    this.setState({ category: value });
  };
  handleTypeChange = value => {
    this.setState({ type: value });
  };
  validateForm = () => {
    if (!this.state.title || this.state.title.length < 2) return false;
    if (!this.state.startDate) return false;
    if (!this.state.category) return false;
    if (!this.state.type) return false;
    return true;
  };

  render() {
    return (
      <div>
        <PanelHeader
          size="sm"
          content={
            <div className="header text-center">
              <h2 className="title">Nuevo recordatorio</h2>
              {/* <p className="category">
                  Calendario de eventos
                </p> */}
            </div>
          }
        />
        <div className={"content "}>
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Form onFinish={this.handleSubmit} layout="vertical" disabled={this.state.creatingReminder}>
                    <Form.Item label="Título">
                      <Input
                        value={this.state.title}
                        onChange={e => this.handleChange(e, "title")}
                      />
                    </Form.Item>
                    <Form.Item label="Descripción">
                      {/* <Input.TextArea
                        value={this.state.description}
                        onChange={e => this.handleChange(e, "description")}
                      /> */}
                    </Form.Item>
                    <Form.Item label="Fecha y hora de inicio">
                      <DatePicker
                        showTime
                        format="DD/MM/YYYY HH:mm"
                        value={
                          this.state.startDate ? this.state.startDate : null
                        }
                        onChange={this.handleDateChange}
                      />
                    </Form.Item>
                    <Form.Item label="Categoría">
                      <Select
                        value={this.state.category}
                        onChange={this.handleCategoryChange}
                      >
                        <Option value="420">Trabajo</Option>
                        <Option value="421">Personal</Option>
                        <Option value="422">Médico</Option>
                        {/* Agrega más opciones según sea necesario */}
                      </Select>
                    </Form.Item>
                    <Form.Item label="Tipo de recordatorio">
                      <Select
                        value={this.state.type}
                        onChange={this.handleTypeChange}
                      >
                        <Option value="415">Para mí</Option>
                        <Option value="416">Para todos</Option>
                        {/* Agrega más opciones según sea necesario */}
                      </Select>
                    </Form.Item>
                    <Form.Item label="Compartido con...">
                      <Select
                        mode="multiple"
                        allowClear
                        className="react-select primary"
                        classNamePrefix="react-select"
                        isMulti
                        closeMenuOnSelect={false}
                        placeholder="Seleccionar compañeros"
                        name="compartido_con"
                        value={this.state.shared}
                        options={this.props.mainState.techniciansList}
                        noOptionsMessage={() => "Cargando compañeros"}
                        onChange={value => this.setState({ shared: value })}
                      />
                    </Form.Item>
                    <Form.Item>
                      <Button color="primary" htmlType="submit" disabled={!this.validateForm() || this.state.creatingReminder}>
                        {this.state.creatingReminder ? <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Guardando</span> : "Guardar"}
                      </Button>
                    </Form.Item>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default NewReminder;



// WEBPACK FOOTER //
// ./src/views/Reminders/NewReminder.jsx